/* eslint-disable*/
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import InfoPopoverCommentsWrapper from '../InfoPopoverCommentsWrapper';

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
    background: '#616468',
    width: '200px',
    overflowX: 'unset',
    overflowY: 'unset',
    '& .MuiTypography-root': {
      color: '#fff',
    },
  },
  InfoIconStyle: {
    color: '#91979D',
    '&:hover': {
      color: '#616569',
    },
  },
}));

export default function InfoPopover({ dashboardComments, dashboardSectionText }) {
  const classes = useStyles();

  return (
    <Box className={classes.popoverOuter} display="flex">
      {/* <InfoIcon
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        className={classes.InfoIconStyle}
      /> */}
      <InfoPopoverCommentsWrapper
        dashboardComments={dashboardComments}
        section="Header"
        title={dashboardSectionText}
      />
      {/* <InfoPopoverCommentsWrapper
        dashboardComments={dashboardComments}
        section="Revenue"
        title={dashboardSectionText}
      /> */}
      {/* <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box>
          <Typography variant="h5">Ranking</Typography>
          <Typography variant="body1">Matrix ranking within the company.</Typography>
        </Box>
        <Box mt={2}>
          <Typography variant="h5">Last Year</Typography>
          <Typography variant="body1">From January 1, 2023 to December 31, 2023.</Typography>
        </Box>
      </Popover> */}
    </Box>
  );
}
